import React from 'react';
import { startsWith } from 'lodash';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import accounting from 'accounting';

function NumberDisplay(props) {
  const {
    value, suffix, suffixIsUnit, withPlus,
  } = props;
  let { precision } = props;

  if (Number.isNaN(value)) {
    return null;
  }
  let plus = '';
  if (value > 0 && withPlus) {
    plus = '+';
  }
  if (precision === null || typeof (precision) === 'undefined') {
    precision = 2;
  }
  let s = null;
  if (suffix) {
    if (suffixIsUnit) {
      s = (
        <span>&nbsp;{pluralize(suffix, value)}</span>
      );
    } else {
      s = suffix;
    }
  }

  let v = accounting.formatNumber(value, precision);
  if (startsWith(v, '100.') && suffix === '%') {
    v = '100';
  }
  if (props.muteDecimal) {
    const per = v.split('.');
    const main = per[0] || '0';
    const sub = main === '100' ? '' : per[1] || '';
    v = (<><span>{main}</span><span className="text-muted">.{sub}</span></>);
  }


  return (
    <span className="number-display">
      {plus}{v}{s}
    </span>
  );
}

NumberDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  precision: PropTypes.number,
  suffix: PropTypes.string,
  suffixIsUnit: PropTypes.bool,
  withPlus: PropTypes.bool,
  muteDecimal: PropTypes.bool,
};
NumberDisplay.defaultProps = {
  value: null,
  suffix: null,
  precision: null,
  suffixIsUnit: false,
  withPlus: false,
  muteDecimal: false,
};

export default NumberDisplay;
